import { render, staticRenderFns } from "./ListagemDocumentosBtnMaisAcoes.vue?vue&type=template&id=7e2f8711&scoped=true"
import script from "./ListagemDocumentosBtnMaisAcoes.vue?vue&type=script&lang=js"
export * from "./ListagemDocumentosBtnMaisAcoes.vue?vue&type=script&lang=js"
import style0 from "./ListagemDocumentosBtnMaisAcoes.vue?vue&type=style&index=0&id=7e2f8711&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2f8711",
  null
  
)

export default component.exports